module.exports = __webpack_public_path__ + "img/img_slide_2.89443657.webp";